// Simple text-to-speech utility using the browser's built-in Web Speech API.
// Free, no API key, works offline. Voice quality depends on the OS.

let hasWelcomed = false; // avoid re-triggering on hot reload

export const speak = (text, options = {}) => {
  if (!('speechSynthesis' in window)) {
    console.warn('Web Speech API not supported');
    return;
  }
  // Cancel any ongoing speech
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(text);
  utter.rate = options.rate ?? 1.0;
  utter.pitch = options.pitch ?? 1.05;
  utter.volume = options.volume ?? 1.0;
  utter.lang = options.lang ?? 'en-US';
  // Pick the best available voice (prefer natural / Google / Samantha / Zira)
  const voices = window.speechSynthesis.getVoices();
  if (voices.length > 0) {
    const preferred = voices.find(v =>
      /google|samantha|zira|natural|premium|alex/i.test(v.name) && v.lang.startsWith('en')
    ) || voices.find(v => v.lang.startsWith('en')) || voices[0];
    if (preferred) utter.voice = preferred;
  }
  window.speechSynthesis.speak(utter);
};

// Speak once per session (survives hot reload but not full page navigation)
export const speakOnce = (key, text, options) => {
  const sessionKey = `voice_played_${key}`;
  if (sessionStorage.getItem(sessionKey) === '1') return;
  sessionStorage.setItem(sessionKey, '1');
  // Give voices a moment to load on first call
  setTimeout(() => speak(text, options), 300);
};

export const resetVoiceOnce = (key) => sessionStorage.removeItem(`voice_played_${key}`);

// Test whether the browser can speak right now (only after user interaction)
export const canSpeakNow = () => {
  return 'speechSynthesis' in window && !hasWelcomed;
};

export default { speak, speakOnce, resetVoiceOnce, canSpeakNow };
